export default {
  props: {
    isParticipantsModuleActiveForThisProject: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    async setPermissionsForShowUserDataInParticipantsList(eventId, setPermissionTo) {
      if (!this.isParticipantsModuleActiveForThisProject) { return Promise.resolve(); }
      if (!eventId) { return Promise.reject(new Error('No EventId set')); }
      if (!(window.KWS && window.KWS.user)) { return Promise.reject(new Error('No KWS user found')); }
      const { user } = window.KWS;
      if (!(user.profile && user.profile.features)) { return Promise.reject(new Error('KWS user found but profile in unsupported state')); }

      const legalPermissions = user.profile.features.legalPermissions ?? {};
      legalPermissions[`show_in_loyalty_event_list_${eventId}`] = setPermissionTo;
      user.profile.features.legalPermissions = legalPermissions;
      return this.$http({
        method: 'put',
        url: `${this.apiUrl}/user`,
        headers: {
          Authorization: `${this.getCookieValue('Authorization')}`,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(user),
      });
    },
  },
};
